/**
 * Quién ve la pestaña FACTURACIÓN del Cuadro de mandos, en un solo sitio.
 *
 * **D-ROL** (dirección, 03/10/2026, #167): solo **ADMIN y DIRECTOR**. Son las cifras de facturación
 * y cobro de la empresa, el pendiente de cobro y los objetivos: no son datos de trabajo, son datos
 * de dirección. Quien no tenga el rol no ve la entrada —ni vacía ni con un aviso de permisos: no
 * está—.
 *
 * Es una restricción **por encima** de la configuración por persona del Cuadro de mandos que ya
 * existe (#34), que no se toca, y no cambia qué ve nadie en ninguna otra pantalla.
 *
 * POR QUÉ UN MÓDULO Y NO LA LISTA DE ROLES ESCRITA EN CADA SITIO: la pregunta la hacen cuatro —la
 * tarjeta del Cuadro de mandos, la ruta de la pestaña, la de la Tarjeta B y la de la Tarjeta A
 * (#170)—. Con la lista copiada, uno de los cuatro contesta distinto antes o después: es exactamente
 * lo que pasó con el permiso del módulo de empleados (revisión del PR #1711), donde la cuarta copia
 * dejaba entrar en una pantalla que luego no se pintaba.
 *
 * POR QUÉ NO VALE `RoutesUtils.checkPermission`: ahí manda el menú de Mongo, y el menú da
 * `/dashboard/` a más roles —`isInMenu` compara con `path.startsWith(link)`—, así que estas rutas
 * quedarían abiertas a cualquiera que tenga el Cuadro de mandos. Esto es una restricción, no una
 * extensión, y una restricción no puede salir de ahí.
 */
const ROLES_PESTANA = ['ADMIN', 'DIRECTOR'];

const PermisosFacturacion = {
    ROLES_PESTANA: ROLES_PESTANA,

    /**
     * Si ese usuario ve la pestaña. **Fail-closed**: sin usuario, sin roles o con otros roles, no.
     *
     * Recibe el usuario en vez de buscarlo, para que quien pregunte decida con cuál: las rutas
     * pasan el que ha traído `Usuario.me()` en esta carga (ver `barreraUsuarioActualizado.js`) y la
     * tarjeta del Cuadro de mandos pasa el de la sesión guardada, que es lo único que tiene a mano.
     * La lógica es una sola, así que las dos contestan lo mismo con el mismo usuario.
     *
     * @param {Object} usuario el usuario, con su `roles`.
     */
    verPestana: function(usuario) {
        const roles = (usuario && usuario.roles) || [];
        return ROLES_PESTANA.some(function(rol) { return roles.indexOf(rol) > -1; });
    }
};

export default PermisosFacturacion;
